import axios from "axios";
import appconfig from "../../../../AppConfig";
import { debug } from "../../../../common/utils";
import { ICart } from "../../../../models";

/** Every order with at least one reservation line, newest first. */
export const getReservationsApi = async (): Promise<ICart[] | undefined> => {
  try {
    const response = await axios.get<ICart[]>("/cart/reservations", {
      baseURL: appconfig.baseURL,
    });
    debug("!!! API - getReservationsApi !!!");
    debug(response);
    return response.data;
  } catch (err) {
    console.log(err);
    return undefined;
  }
};
